module.exports = __webpack_public_path__ + "img/avatar-fee07e00.0f1974a5.jpg";